import React, { useState } from "react";

const services = [
  {
    color: '#E8611A',
    bg: 'rgba(232,97,26,0.09)',
    icon: (
      <svg width="22" height="22" fill="none" stroke="#E8611A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
    title: "Conseil & Stratégie",
    items: ["Audit et Benchmark", "Stratégie digitale", "Transformation digitale", "Formations"],
    link: '/etude-conseil',
  },
  {
    color: '#16a34a',
    bg: 'rgba(22,163,74,0.09)',
    icon: (
      <svg width="22" height="22" fill="none" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/><path d="M22 12A10 10 0 0 0 12 2v10z"/>
      </svg>
    ),
    title: "Digital Marketing",
    items: ["Site E-commerce", "Campagnes d'e-mailing", "Référencement (SEO, SEA, SMO)", "Social media marketing"],
    link: '/web-media',
  },
  {
    color: '#7c3aed',
    bg: 'rgba(124,58,237,0.09)',
    icon: (
      <svg width="22" height="22" fill="none" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
        <polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/>
      </svg>
    ),
    title: "Développement Web & Mobile",
    items: ["Portail web", "Application mobile", "Collecte de données", "Plateforme de visualisation"],
    link: '/ict-consulting',
  },
];

function ServiceCard({ s }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.75)',
        backdropFilter: 'blur(12px)',
        border: hovered ? `1px solid ${s.color}40` : '1px solid rgba(0,0,0,0.06)',
        borderRadius: 20,
        padding: '28px 26px',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        transition: 'background .25s, border-color .25s, transform .25s, box-shadow .25s',
        transform: hovered ? 'translateY(-5px) scale(1.01)' : 'none',
        boxShadow: hovered ? `0 20px 40px rgba(0,0,0,0.12), 0 0 0 1px ${s.color}20` : '0 4px 16px rgba(0,0,0,0.06)',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'default',
      }}
    >
      {hovered && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 2,
          background: `linear-gradient(90deg, transparent, ${s.color}, transparent)`,
        }} />
      )}
      <div style={{
        width: 52, height: 52, borderRadius: 14,
        background: s.bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        {s.icon}
      </div>

      <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>
        {s.title}
      </h3>

      <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 9 }}>
        {s.items.map((item, i) => (
          <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.845rem', color: '#64748b' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={s.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12"/>
            </svg>
            {item}
          </li>
        ))}
      </ul>

      <a href={s.link} style={{
        marginTop: 4,
        display: 'inline-flex', alignItems: 'center', gap: 5,
        fontSize: '0.8rem', fontWeight: 600, color: s.color,
        textDecoration: 'none',
      }}>
        En savoir plus
        <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
      </a>
    </div>
  );
}

const ServicesCards = () => {
  return (
    <section style={{
      background: 'linear-gradient(135deg, #fff7ed 0%, #ffffff 50%, #f8fafc 100%)',
      padding: '52px 0 48px',
      fontFamily: "'DM Sans', sans-serif",
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Dot pattern */}
      <div style={{ position: 'absolute', inset: 0, opacity: 0.4, pointerEvents: 'none', backgroundImage: 'radial-gradient(circle, #e2e8f0 1px, transparent 1px)', backgroundSize: '28px 28px' }} />

      {/* Colored blobs */}
      <div style={{ position: 'absolute', top: '-10%', right: '10%', width: 300, height: 300, borderRadius: '50%', background: 'radial-gradient(circle, rgba(232,97,26,0.15) 0%, transparent 70%)', filter: 'blur(50px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-10%', left: '5%', width: 260, height: 260, borderRadius: '50%', background: 'radial-gradient(circle, rgba(22,163,74,0.12) 0%, transparent 70%)', filter: 'blur(50px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: '40%', left: '40%', width: 200, height: 200, borderRadius: '50%', background: 'radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 70%)', filter: 'blur(40px)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>

        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '6px 18px', borderRadius: 999,
            border: '1px solid rgba(232,97,26,0.3)',
            background: 'rgba(232,97,26,0.08)',
            marginBottom: 14,
          }}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="#E8611A"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#E8611A', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Nos services</span>
          </div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: 800, color: '#1e293b', margin: '0 0 10px' }}>
            Ce que nous faisons pour vous
          </h2>
          <div style={{ width: 36, height: 2, background: 'linear-gradient(90deg, #E8611A, #16a34a)', borderRadius: 4, margin: '0 auto' }} />
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 20,
        }}>
          {services.map((s, i) => <ServiceCard key={i} s={s} />)}
        </div>

      </div>
    </section>
  );
};

export default ServicesCards;
